import { render, staticRenderFns } from "./RecentCheckins.vue?vue&type=template&id=a6931bf8"
import script from "./RecentCheckins.vue?vue&type=script&lang=ts"
export * from "./RecentCheckins.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports